// extracted by mini-css-extract-plugin
var _1 = "oW3bD";
var _2 = "DBhNt";
export { _1 as "base", _2 as "collapsableTitle" }
